import React, { useState } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import CardContact from '../components/cards/cardContact/CardContact';

import { ICategory, IContact } from './types';

import SvgArrow from '../svg/Arrow';
import { useSelector } from 'react-redux';
import { translate } from '../i18n';
import { RootState } from '../store';
import axios from '../api/axios';
import './Directory.css';
import CardCategory from '../components/cards/cardCategory/CardCategory';
import { useParams } from 'react-router-dom';

interface IContactPageProps {}

const ContactPage: React.FC<IContactPageProps> = () => {
    const [selectedTab, setSelectedTab] = useState(-1);
    const [contacts, setContacts] = useState<IContact[]>(new Array<IContact>());
    const [categories, setCategories] = useState<ICategory[]>(new Array<ICategory>());
    const { language } = useSelector((state: RootState) => state.lang);

    const params = useParams();
    const buildingId = params.buildingId;

    const GET_CONTACT_CATEGORIES_URL = '/api/hblogin/repository/GetContactCategoriesByBuildingId';
    const GET_CONTACTS_URL = '/api/hblogin/repository/GetContactsByBuildingId';

    const updateCategories = (categories: ICategory[]) => {
        categories = categories.sort(function (a, b) {
            if (a.frenchTitle.toLowerCase() < b.frenchTitle.toLowerCase()) return -1;
            if (a.frenchTitle.toLowerCase() > b.frenchTitle.toLowerCase()) return 1;
            return 0;
        });
        setCategories(categories);
    };

    const updateContacts = (contacts: IContact[]) => {
        contacts = contacts.sort(function (a, b) {
            if (a.positionFrench.toLowerCase() < b.positionFrench.toLowerCase()) return -1;
            if (a.positionFrench.toLowerCase() > b.positionFrench.toLowerCase()) return 1;
            return 0;
        });
        setContacts(contacts);
    };

    React.useEffect(() => {
        axios.get<ICategory[]>(`${GET_CONTACT_CATEGORIES_URL}`, { params: { buildingId: buildingId } }).then((response) => updateCategories(response.data));
        axios.get<IContact[]>(`${GET_CONTACTS_URL}`, { params: { buildingId: buildingId } }).then((response) => updateContacts(response.data));
    }, []);

    return (
        <div className="Directory">
            <div className="DirectoryLeft">
                <div className="CategoryListOuter">
                    <div className="CategoryListHeader">{translate('Contacts', language)}</div>
                    <ScrollContainer className="CategoryListBody TouchScroll" horizontal={false}>
                        {categories.map((item, i) => (
                            <CardCategory key={i} index={item.id} englishTitle={item.englishTitle} frenchTitle={item.frenchTitle} setSelectedTab={setSelectedTab} activeTab={item.id === selectedTab} />
                        ))}
                    </ScrollContainer>
                    <div className="CategoryListFooter">
                        <button className="CategoryCardOuter CategoryDisplayAll Drop-Shadow " onClick={() => setSelectedTab(-1)}>
                            <div className="CategoryDisplayAllTitle">{translate('DisplayAll', language)}</div>
                            <SvgArrow height={30} width={30} color="#FFFFFF" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="DirectoryRight TouchScroll">
                <ScrollContainer className="ContactDataOuter TouchScroll" horizontal={false} vertical={true}>
                    {contacts?.map((item, i) =>
                        item.categoryId === selectedTab ? (
                            <CardContact
                                id={item.id}
                                name={item.name}
                                userId={item.userId}
                                positionEnglish={item.positionEnglish}
                                positionFrench={item.positionFrench}
                                phoneFrench={item.phoneFrench}
                                phoneEnglish={item.phoneEnglish}
                                emailFrench={item.emailFrench}
                                emailEnglish={item.emailEnglish}
                                key={i}
                            />
                        ) : selectedTab === -1 ? (
                            <CardContact
                                name={item.name}
                                id={item.id}
                                userId={item.userId}
                                positionEnglish={item.positionEnglish}
                                positionFrench={item.positionFrench}
                                phoneFrench={item.phoneFrench}
                                phoneEnglish={item.phoneEnglish}
                                emailFrench={item.emailFrench}
                                emailEnglish={item.emailEnglish}
                                key={i}
                            />
                        ) : null
                    )}
                </ScrollContainer>
            </div>
        </div>
    );
};

export default ContactPage;
